import { actions as UserActions } from 'app/modules/user'
import { trackEvent, trackPageView } from 'utils/tracking'

/**
 * @depreacted Use utils/tracking/trackEvent
 */
export const track = (eventName, properties) => dispatch => (
  dispatch(UserActions.fetchCurrentUser())
    .then(() => {
      trackEvent(eventName, properties)
    })
)

/**
 * @depreacted Use utils/tracking/trackPageView
 */
export const page = () => () => { trackPageView() }



// WEBPACK FOOTER //
// ./src/scripts/app/modules/tracking/actions.js